import {
  ChatBubbleBottomCenterTextIcon,
  EllipsisHorizontalCircleIcon,
  MegaphoneIcon,
  MinusSmallIcon,
  PhotoIcon,
  RectangleGroupIcon,
  StopIcon,
} from '@heroicons/react/24/outline';

export interface LayerItemProps {
  readonly objectId: string;
  readonly label: string;
  readonly type: string;
  readonly isSelected: boolean;
  readonly onClick: () => void;
}

const TYPE_ICON: Record<string, typeof StopIcon> = {
  text: ChatBubbleBottomCenterTextIcon,
  'i-text': ChatBubbleBottomCenterTextIcon,
  textbox: ChatBubbleBottomCenterTextIcon,
  image: PhotoIcon,
  group: RectangleGroupIcon,
  rect: StopIcon,
  circle: EllipsisHorizontalCircleIcon,
  ellipse: EllipsisHorizontalCircleIcon,
  line: MinusSmallIcon,
  'banner-cta': MegaphoneIcon,
};

export function LayerItem({ label, type, isSelected, onClick }: LayerItemProps) {
  const Icon = TYPE_ICON[type] ?? StopIcon;

  return (
    <button
      type="button"
      onClick={onClick}
      className={[
        'mb-quark flex w-full items-center gap-nano rounded-sm border-hairline px-nano py-micro text-left transition-colors',
        isSelected
          ? 'border-ctx-interactive-primary bg-ctx-interactive-secondary text-ctx-content-title'
          : 'border-transparent bg-ctx-layout-body text-ctx-content-base hover:border-ctx-layout-border hover:bg-ctx-layout-surface',
      ].join(' ')}
    >
      <Icon className="h-mmicro w-micro shrink-0 text-ctx-content-placeholder" />
      <span className="flex-1 truncate ts-caption-xxs">{label}</span>
    </button>
  );
}
